import { Element, Node } from 'slate';
import { RenderElementProps } from 'slate-react';
import { CustomEditor, CustomElement, ImportAreaElement } from 'slate/types/slate';
import { isReferenceTable } from '../reference-table';
import { TableRenderer } from './components/TableRenderer';

const isImportArea = (node: Node): node is ImportAreaElement => Element.isElement(node) && node.type === 'import-area';

const withImportArea =
  (options: { withComments?: boolean; withTags?: boolean; readOnly?: boolean } = {}) =>
  (editor: CustomEditor) => {
    const { isVoid, renderElement } = editor;
    const withComments = options.withComments ?? false;
    const withTags = options.withTags ?? false;
    editor.isVoid = (element: CustomElement) => isImportArea(element) || isReferenceTable(element) || isVoid(element);

    editor.renderElement = (props: RenderElementProps) => {
      if (isReferenceTable(props.element)) {
        return <TableRenderer props={props} withComments={withComments} withTags={withTags} readOnly={options.readOnly} />;
      } else {
        return renderElement(props);
      }
    };

    return editor;
  };

export default withImportArea;
